import {
  AUTH_USER,
  AUTH_USER_OUT,
  FORGOT_PASSWORD,
  UPDATE_PASSWORD,
} from './types';

import { Auth } from './api';

export const signUpAction = (
  full_name,
  email,
  password,
  agreeToTerms,
  receiveEmail,
  reservationToken,
  trialToken,
  expectedAccounts,
  expectedPlan,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Auth.signUp(
    full_name,
    email,
    password,
    agreeToTerms,
    receiveEmail,
    reservationToken,
    trialToken,
    expectedAccounts,
    expectedPlan,
  );
  if (response.status === 200) {
    dispatch({
      type: AUTH_USER,
      token: response.headers.authorization,
      user: response.data,
      isUserLoggedIn: true,
    });
    setSubmitting(false);
  } else {
    setErrors({
      email: response.error,
      password: response.error,
    });
    setSubmitting(false);
  }
  return response;
};

export const sendUpdatePasswordAction = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Auth.updatePassword(body);
  if (response.status === 200) {
    dispatch({
      type: UPDATE_PASSWORD,
    });
  }
  return response;
};

export const sendForgotPasswordEmailAction = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Auth.forgotPassword(body);
  if (response.status === 200) {
    dispatch({
      type: FORGOT_PASSWORD,
    });
  } else {
    setErrors({
      email: response.error,
    });
  }
  setSubmitting(false);
  return response;
};

export const signInAction = (
  email,
  password,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Auth.signIn(email, password);
  if (response.status === 200) {
    dispatch({
      type: AUTH_USER,
      token: response.token,
      user: response.user,
      isUserLoggedIn: true,
    });
    setSubmitting(false);
  } else {
    setErrors({
      email: response.error,
      password: response.error,
    });
    setSubmitting(false);
    return response;
  }
};

export const signOutAction = () => async dispatch => {
  const response = await Auth.signOut();
  if (!response.error) {
    dispatch({ type: AUTH_USER_OUT });
  } else {
    return response.error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js